module.exports = __webpack_public_path__ + "img/cb-settings.b6f6431a.svg";